import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator, enableNetwork, disableNetwork } from 'firebase/firestore'

// Firebase configuration - using environment variables for better security
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyB8JuZ3mh1BTgo9YMb0ViOJ3pviiaN_KW0",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "mimedicacion-30915.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "mimedicacion-30915",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "mimedicacion-30915.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "944310539444",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:944310539444:web:4f7145d4a73bc09486b3e1"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({
  prompt: 'select_account'
})

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app)

// Configuración mejorada para resolver problemas de conectividad
const configureFirestoreSettings = () => {
  // Solo configurar en desarrollo para evitar problemas de producción
  if (process.env.NODE_ENV === 'development') {
    console.log('🔧 Configurando Firestore para desarrollo...')
    
    // Configurar para forzar long polling en lugar de WebSocket
    // Esto resuelve muchos problemas de conectividad
    try {
      // Estas configuraciones ayudan con problemas de QUIC y WebSocket
      const settings = {
        ignoreUndefinedProperties: true,
        cacheSizeBytes: 1048576, // 1MB cache
        experimentalForceLongPolling: true, // Evita errores de WebSocket
        merge: true
      }
      
      // Aplicar configuración
      console.log('⚙️  Aplicando configuración de Firestore')
      
    } catch (error) {
      console.warn('⚠️  Error configurando Firestore:', error)
    }
  }
}

// Función para manejar errores de conectividad
export const handleFirestoreConnectivityIssues = async () => {
  try {
    console.log('🔄 Reiniciando conexión de Firestore...')
    
    // Desactivar y reactivar la red para resetear la conexión
    await disableNetwork(db)
    await enableNetwork(db)
    
    console.log('✅ Conexión de Firestore reiniciada')
    return true
  } catch (error) {
    console.error('❌ Error reiniciando conexión:', error)
    return false
  }
}

// Función para configurar listeners de errores
export const setupFirebaseErrorHandling = () => {
  // Escuchar errores de Firebase y reintentar conexión
  window.addEventListener('error', (event) => {
    if (event.error && event.error.message) {
      const message = event.error.message.toLowerCase()
      
      if (message.includes('quic') || 
          message.includes('websocket') || 
          message.includes('webchannel') ||
          message.includes('transport errored')) {
        
        console.log('🔄 Detectado error de conectividad, reintentando...')
        
        // Reintentar conexión después de un breve delay
        setTimeout(() => {
          handleFirestoreConnectivityIssues()
        }, 1000)
      }
    }
  })
  
  // Escuchar promesas rechazadas
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message) {
      const message = event.reason.message.toLowerCase()
      
      if (message.includes('firestore') && 
          (message.includes('network') || message.includes('connection'))) {
        
        console.log('🔄 Detectado error de red en Firestore, reintentando...')
        
        // Reintentar conexión
        setTimeout(() => {
          handleFirestoreConnectivityIssues()
        }, 2000)
      }
    }
  })
}

// Ejecutar configuración al inicializar
configureFirestoreSettings()
setupFirebaseErrorHandling()

// Default export
export default app 